export const SET_ERROR = 'SET_ERROR'
export const errorPlayerPath = 'player'

export interface ErrorType {
  showErrorModal?: boolean
  errorCode?: string
  HTTPcode?: string | number
  fetchAction?: string
  videoSlug?: string
  category?: string
  movieId?: string
  pathLocation?: string
  feedPageSlug?: string
  feedSubscriptionPlan?: string
}

export const setError = (payload: ErrorType) => ({
  type: SET_ERROR,
  payload,
})

export interface ErrorAction {
  type: string
  payload: ErrorType
}
